import React from "react";
import { Deco, DecoProps } from "../components/Deco";
import { Flex } from "../layouts/Flex";
import { MaxWidth } from "../layouts/MaxWidth";
import { Spacing } from "../layouts/Spacing";
import styles from "./Facts.module.css";

export type FactProps = {
  amount: string;
  text: string;
  decoration: DecoProps["deco"];
};

export const Fact = ({
  amount,
  text,
  decoration = "dashed-underline",
}: FactProps) => {
  return (
    <div className={styles.fact}>
      <span className={styles.amount}>
        <Deco deco={decoration}>{amount}</Deco>
      </span>
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export type FactsProps = {
  items: FactProps[];
};

export const Facts = ({ items }: FactsProps) => {
  if (!items) return null;
  return (
    <div className={styles.container}>
      <Spacing>
        <MaxWidth size="lg">
          <Flex items={3} align="center">
            {items.map((item, index) => (
              <Fact key={item.amount} {...item} />
            ))}
          </Flex>
        </MaxWidth>
      </Spacing>
    </div>
  );
};
